import type { JSX } from 'react';

import { FloatingWhatsAppButton } from './layout/FloatingWhatsAppButton';
import { Footer } from './layout/Footer';
import { Navbar } from './layout/Navbar';
import { ComoFunciona } from './sections/ComoFunciona';
import { CtaFinal } from './sections/CtaFinal';
import { Diferenciais } from './sections/Diferenciais';
import { Faq } from './sections/Faq';
import { Hero } from './sections/Hero';
import { Problema } from './sections/Problema';
import { QuemSomos } from './sections/QuemSomos';
import { Servicos } from './sections/Servicos';

/**
 * Page shell que monta todas as secoes da landing na ordem do PRD §4.
 *
 * Phase 5 (atual — landing completa): Navbar -> Hero -> QuemSomos -> Problema
 * -> Servicos -> ComoFunciona -> Diferenciais -> Faq -> CtaFinal -> Footer
 * + FloatingWhatsAppButton (PRD §4.2 ate §4.10). Cobre todas as secoes
 * narrativas do PRD; Phase 6 cuida de QA/Analytics/Deploy.
 *
 * Acessibilidade: o `<main>` aqui e o unico landmark `main` da pagina; cada
 * section interna tem `<h2>` (Hero usa `<h1>`) formando arvore semantica
 * valida (PRD §7.6). Navbar `<nav>` e Footer `<footer>` ficam FORA do `<main>`
 * como landmarks de mesmo nivel.
 *
 * Ritmo visual entre secoes:
 *   Hero (bg-neutral-50)
 *   -> QuemSomos (bg-white)
 *   -> Problema (bg-neutral-50)
 *   -> Servicos (bg-white)
 *   -> ComoFunciona (bg-neutral-50)
 *   -> Diferenciais (bg-brand-900 — banda dark-green do design-reference)
 *   -> Faq (bg-white — volta pro light apos a banda dark)
 *   -> CtaFinal (bg-brand-700 — segunda banda verde, mais clara, com botao
 *      branco invertido)
 *   -> Footer (bg-neutral-900 — pause institucional final, gray-almost-black)
 */
export const LandingPage = (): JSX.Element => (
  <>
    <Navbar />
    <main>
      <Hero />
      <QuemSomos />
      <Problema />
      <Servicos />
      <ComoFunciona />
      <Diferenciais />
      <Faq />
      <CtaFinal />
    </main>
    <Footer />
    <FloatingWhatsAppButton />
  </>
);
